export default "__VITE_ASSET__f24f0596__"